// ======================================================================
// FILE:
// src/modules/finance/components/FinanceStatusBadge.jsx
//
// MODULE:
// Finance & Accounts Management System (FBAMS)
//
// COMPONENT:
// Finance Status Badge
//
// PURPOSE:
// Displays Journal Status and Approval Status.
//
// FEATURES:
// - Bootstrap badges
// - Consistent colors
// - Journal Status
// - Approval Status
// - Responsive
//
// AUTHOR:
// DizyPro ERP
// ======================================================================

import React from "react";

// ======================================================================
// STATUS CONFIGURATION
// ======================================================================

const JOURNAL_STATUS = {

    DRAFT: {
        className: "bg-secondary",
        icon: "fas fa-pencil-alt",
        label: "Draft",
    },

    APPROVED: {
        className: "bg-primary",
        icon: "fas fa-check",
        label: "Approved",
    },

    POSTED: {
        className: "bg-success",
        icon: "fas fa-check-double",
        label: "Posted",
    },

    REVERSED: {
        className: "bg-dark",
        icon: "fas fa-undo",
        label: "Reversed",
    },

    CANCELLED: {
        className: "bg-danger",
        icon: "fas fa-times",
        label: "Cancelled",
    },

};

const APPROVAL_STATUS = {

    PENDING: {
        className: "bg-secondary",
        icon: "far fa-clock",
        label: "Pending",
    },

    SUBMITTED: {
        className: "bg-warning text-dark",
        icon: "fas fa-paper-plane",
        label: "Submitted",
    },

    APPROVED: {
        className: "bg-success",
        icon: "fas fa-check-circle",
        label: "Approved",
    },

    REJECTED: {
        className: "bg-danger",
        icon: "fas fa-ban",
        label: "Rejected",
    },

};

// ======================================================================
// COMPONENT
// ======================================================================

export default function FinanceStatusBadge({

    type = "journal",

    value,

}) {

    const config =
        type === "approval"
            ? APPROVAL_STATUS[value]
            : JOURNAL_STATUS[value];

    if (!config) {

        return (

            <span className="badge bg-light text-dark">

                {value || "-"}

            </span>

        );

    }

    return (

        <span
            className={`badge ${config.className}`}
            style={{
                padding: "6px 10px",
                fontSize: 12,
                borderRadius: 20,
            }}
        >

            <i
                className={`${config.icon} me-1`}
            />

            {config.label}

        </span>

    );

}